import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { accountTxns } from "../../actions/categories";
import { amountFormat } from "../../utils";
import Table from "../Common/Table/Table";
import PageHeader from "./../PageHeader";
import BaseCurrency from "../Common/BaseCurrency";
import usePayAxios from "../../config/useAxios";
import { apis } from "../../config/APIs";
import useDownloadCSV from "../../config/useDownloadCSV";
import useDownloadPDF from "../../config/useDownloadPDF";
import { message } from "antd";
import Loader from "../Loader";

const AccountTransaction = () => {
  const dispatch = useDispatch();
  const downloadCSV = useDownloadCSV();
  const downloadPDF = useDownloadPDF();

  // 🔹 correct shape: txns contains both data and loading
  const { data: accounts, loading: accLoading } = useSelector(
    (state) => state?.account?.txns || {},
  );

  const { onCall, loading } = usePayAxios({
    api: apis.credit_transactions_pdf,
    method: "get",
  });

  React.useEffect(() => {
    dispatch(accountTxns({ pageNo: 0, pageSize: 10 }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearch = (val) => {
    // If empty search, fetch default list
    if (!val) {
      dispatch(accountTxns());
      return;
    }

    // Call API with search filter
    dispatch(
      accountTxns({
        tnxRefNo: val, // filtering by transaction ID
      }),
    );
  };

  const columns = [
    {
      title: "Transaction ID",
      dataIndex: "tnxRefNo",
      key: "tnxRefNo",
      render: (text, data) => (
        <div className={`render_common_style status_${data?.Status}`}>
          {text}
        </div>
      ),
    },
    {
      title: "Description",
      dataIndex: "txnDescription",
      key: "txnDescription",
    },
    { title: "Date-Time", dataIndex: "txnDateAndTime", key: "txnDateAndTime" },
    {
      title: "Amount",
      dataIndex: "txnAmount",
      key: "txnAmount",
      render: (text) => (
        <div>
          <BaseCurrency />
          {amountFormat(text)}
        </div>
      ),
    },
  ];

  // 🔹 show a global loader while waiting for first response
  if (accLoading && !accounts?.response?.content) {
    return <Loader />;
  }

  return (
    <>
      <div className="heading-div">
        <PageHeader
          title="Account"
          navigation={{
            Home: "/dashboard/",
            Account: "/account/",
            Transactions: "/account-transaction/",
          }}
        />
      </div>
      <Table
        rowKey="id"
        columns={columns}
        isTopFilter={true}
        hasExport={true}
        data={accounts?.response?.content || []}
        loading={accLoading}
        placeholder={"Search by Transaction ID"}
        pagination={{
          total: accounts?.total_records || 0,
          onChange: (pagee) => {
            dispatch(accountTxns({ pageNo: pagee - 1, pageSize: 10 }));
          },
        }}
        handleSearch={handleSearch}
        onExport={(val) => {
          onCall({ params: { format: val?.toLowerCase() } }).then((res) => {
            if (res.status) {
              if (val === "CSV") {
                downloadCSV(res?.response, `transactions.csv`);
              } else {
                downloadPDF(res?.response, `transactions.pdf`);
              }
            }
          });
        }}
        filterMenu={true}
        isMore={true}
        className="tableStyled"
        topFilters={[
          { label: "All Transactions", action: () => {} },
          { label: "Advance Search", action: () => {} },
        ]}
        exportLoading={loading}
      />
    </>
  );
};

export default AccountTransaction;
